import { Box } from 'components'

const CardTitle = ({title, color}) => {
  return (
    <Box fontSize='20px' lineHeight='150%' fontWeight={600} color={color}>{title}</Box>
  )
}

export default CardTitle